import React from 'react';

import { features } from '../../../constants';
import { Feature } from '../../../components';



const HomeFeatures = () => {

  return (
    <section className='features'>

      {/* Container for feature items */}
      <div className="box-container">

        {/* Map through the first four features and render each feature */}
        {features.slice(0, 4).map((feature) => (
          <Feature key={feature.id} feature={feature} />
        ))}

      </div>

    </section>
  );
}

export default HomeFeatures;